"use client";
import React from "react";
import { motion } from "motion/react";


export const TestimonialsColumn = (props: {
  className?: string;
  testimonials: typeof testimonials;
  duration?: number;
}) => {
  return (
    <div className={props.className}>
      <motion.div
        animate={{
          translateY: "-50%",
        }}
        transition={{
          duration: props.duration || 10,
          repeat: Infinity,
          ease: "linear",
          repeatType: "loop",
        }}
        className="flex flex-col gap-6 pb-6 bg-background"
      >
        {[
          ...new Array(2).fill(0).map((_, index) => (
            <React.Fragment key={index}>
              {props.testimonials.map(({ text, image, name, role }, i) => (
                <div className="p-10 rounded-3xl border shadow-lg shadow-primary/10 max-w-xs w-full" key={i}>
                  <div>{text}</div>
                  <div className="flex items-center gap-2 mt-5">
                    <img
                      width={40}
                      height={40}
                      src={image}
                      alt={name}
                      className="h-10 w-10 rounded-full"
                    />
                    <div className="flex flex-col">
                      <div className="font-medium tracking-tight leading-5">{name}</div>
                      <div className="leading-5 opacity-60 tracking-tight">{role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </React.Fragment>
          )),
        ]}
      </motion.div>
    </div>
  );
};

// Testimonials data for Kaya
export const testimonials = [
  {
    text: "Kaya is the only AI assistant that never censors my requests. I can discuss any topic openly and get genuine help with my coding projects.",
    image: "https://randomuser.me/api/portraits/women/1.jpg",
    name: "Alex Johnson",
    role: "Software Developer",
  },
  {
    text: "The voice chat feature is incredible! Kaya understands my requests perfectly and responds without any of the restrictions I've experienced with other AIs.",
    image: "https://randomuser.me/api/portraits/men/2.jpg",
    name: "Michael Chen",
    role: "AI Researcher",
  },
  {
    text: "As a content creator, I appreciate having an assistant that doesn't limit my creative discussions. Kaya is truly unrestricted in the best way.",
    image: "https://randomuser.me/api/portraits/women/3.jpg",
    name: "Sarah Williams",
    role: "Content Creator",
  },
  {
    text: "Kaya's coding assistance is unmatched. I can ask for help with any programming language or framework without worrying about restrictions.",
    image: "https://randomuser.me/api/portraits/men/4.jpg",
    name: "David Rodriguez",
    role: "Full Stack Developer",
  },
  {
    text: "The uncensored nature of Kaya makes it perfect for research and brainstorming. I never have to worry about hitting content barriers.",
    image: "https://randomuser.me/api/portraits/women/5.jpg",
    name: "Emma Thompson",
    role: "Research Analyst",
  },
  {
    text: "Finally, an AI assistant that treats me as an adult and doesn't arbitrarily restrict conversations. Kaya respects my intelligence.",
    image: "https://randomuser.me/api/portraits/women/6.jpg",
    name: "James Wilson",
    role: "Tech Entrepreneur",
  },
  {
    text: "Kaya's voice interaction is so natural and unrestricted. It feels like having a genuine conversation with an intelligent assistant.",
    image: "https://randomuser.me/api/portraits/men/7.jpg",
    name: "Robert Kim",
    role: "Product Manager",
  },
  {
    text: "I've tried many AI assistants, but Kaya is the only one that truly delivers on complete freedom of conversation and assistance.",
    image: "https://randomuser.me/api/portraits/women/8.jpg",
    name: "Lisa Anderson",
    role: "UX Designer",
  },
  {
    text: "The unrestricted coding help has accelerated my development workflow. Kaya assists with complex problems without any artificial limitations.",
    image: "https://randomuser.me/api/portraits/men/9.jpg",
    name: "Thomas Brown",
    role: "DevOps Engineer",
  },
];